<template>
  <div
    id="re-order"
    v-if="$auth.check() && reOrderItems.length > 0 && checkLastCartExist"
    style="box-shadow: rgba(0, 0, 0, 0.3) 0px 20px 22px 0px;"
    class="xs-fill-white"
  >
    <div class="xs-flex xs-z-300 p-10 pt-5">
      <h4>{{ $t("your_last_order") }}</h4>
    </div>

    <div class="p-10 pb-0">
      <label v-if="$session.get('lang') != 'en'" class=" last-address btn--secondary btn--lg w-full"> 
      {{ result.orderType == $const.DELIVERY.charAt(0) ?  result.locationName + ' ' +  $t('delivery_to') : result.outletAddress +' '+ $t('take_away')}}
      </label>
      <label v-else class=" last-address btn--secondary btn--lg w-full"> 
      {{ result.orderType == $const.DELIVERY.charAt(0) ?   $t('delivery_to') + ' ' + result.locationName : $t('take_away') +' '+ result.outletAddress}}
      </label>
    </div>
    <div v-for="(reOrderItem, i) in reOrderItems" :key="i">
      <div id="item-order" class="xs-flex xs-z-300 p-10 pt-5 item-re-order">
        <span>{{ reOrderItem.quantity }}x </span>
        <span class="mr-l-4">{{ reOrderItem.name }}
          <div class="mr-l-4" v-for="(item, i) in reOrderItem.items" :key="i + 'L'">
            <div>
              <span v-if="item.half_half" class="sub-item dpl-block">{{ i==0 ?  $t('left_half') : $t('right_half') }}</span>
              <p v-if="item.half_half" class="dpl-block mr-l-4"> {{ item.first.name ? '( '+item.first.name +' )' : '' }} {{item.name}} </p>
              <span v-else class="dpl-block sub-item"> {{ item.first.name ? '( '+item.first.name +' )' : '' }} {{item.name}} </span>
              <p class="dpl-block mr-l-4">{{item.first.second.name}}</p>
            </div> 
          </div>
        </span>
        <span class="price fl-right"
          >{{ $const.CURRENCY }}{{ reOrderItem.price }}</span
        >
      </div>
      <div v-if="i == limitShowMore">
        <a
          href="javascript:void(0)"
          class="xs-flex xs-z-300 p-10 pt-5 color-view-more"
          @click="showAll()"
          v-if="showViewMore"
        >
          <span
            >{{
              viewMore && reOrderItems.length > limitShowMore
                ? $t("reorder.view_more")
                : $t("reorder.view_less")
            }}
            <i class="fa fa-angle-down header-time__arrow--down aline-mid"></i>
          </span>
        </a>

        <div class=" xs-flex xs-z-300 p-10 pt-5">
          <div
            id="order-last-order"
            class="btn btn--primary pt-10 btn-re-order"
            v-on:click.stop="checkValidOutlet"
          >
            <div class="fw-normal fl-left mb-5">{{ $t("reorder.order") }}</div>
            <div class="fw-normal fl-right mb-5">
              {{ $const.CURRENCY }}{{ subTotal }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ASAPPopup from '../popup/OrderASAP.vue'
import {
  mapActions
} from 'vuex'
import * as types from '@/store/types'
export default {
  data() {
    return {
      reOrderItems: [],
      arrItems: [],
      viewMore: true,
      showViewMore: true,
      limitShowMore: this.$const.LIMIT_VIEW_MORE,
      subTotal: 0,
      disposition: {},
      location_code: "",
      checkLastCartExist: true,
      params: {
        last_cart_uuid: "",
        order_type: "",
        outlet_id: "",
        order_time: "",
        advance_order: "",
        outlet_code: ""
      },
      oldOrder: {},
      result: {
        outletAddress: "",
        orderType: "",
        locationName: "",
        prefectureName: "",
        cityName: "",
        villeageName: "",
        st: "",
        outletId: "",
        addressCode: ""
      }
    };
  },
  created() {
    this.getOldUUID();
  },
  beforeDestroy () {
    this.$root.$off('onCheckValidOutletReOrder')
  },
  mounted () {
    let vm = this
    this.$root.$on('onCheckValidOutletReOrder', (data) => {
      vm.checkValidOutlet()
    })
  },
  methods: {
    ...mapActions({
      setDisposition: types.SET_DISPOSITION,
      setShowModalTakeAwayLess: types.SET_SHOW_MODAL_TAKE_AWAY_LESS,
    }),
    getOldUUID() {
      let vm = this;
      let params = {
        limit: 1,
        page: 1,
        sort_by: "updated_at",
        order_by: "desc"
      };
      this.axios.apiOrder.listOrderByUser(
        params,
        function(response) {
          let oldOrder = response.data.data.items
            ? response.data.data.items[0].uuid
            : "";
            vm.location_code = response.data.data.items
            ? response.data.data.items[0].address_code2
            : "";

          let oldCart = response.data.data.items
            ? response.data.data.items[0].cart_uuid
            : "";
          vm.checkLastCartExist = oldCart !== "" ? true : false
          if(vm.checkLastCartExist) {
            vm.getLastCartDetail(oldCart, oldOrder)
          }
        },
        function(err) {
          console.log("err_reOder", err);
        }
      );
    },
    getLastCartDetail (oldCartUUID, oldOrderUUID) {
      let vm = this
      vm.axios.apiCart.getLastCartdetail(oldCartUUID,
      function (response) {
        if (response.data.status) {
          vm.getLastOrder(oldOrderUUID);
        }
        vm.checkLastCartExist = response.data.status
      },
      function (error) {
        console.log("error", error)
        vm.checkLastCartExist = false
      })
    },
    getLastOrder(uuid) {
      let vm = this;
      this.axios.apiOrder.getOrder(
        uuid,
        function(response) {
          vm.oldOrder = response.data.data.item;
          let deliveryAddress = vm.oldOrder.delivery_address;
          vm.result.locationName = vm.oldOrder.address_name2 || vm.oldOrder.address;
          vm.result.outletAddress = vm.oldOrder.outlet_name
          vm.result.outletId = vm.oldOrder.outlet_id
          
          vm.result.prefectureName = deliveryAddress && deliveryAddress.prefecture || "";
          vm.result.cityName = deliveryAddress && deliveryAddress.city || "";
          vm.result.villeageName = deliveryAddress && deliveryAddress.town || "";
          vm.result.st = deliveryAddress && deliveryAddress.st || "";
          vm.result.orderType = vm.oldOrder.order_type;
          vm.result.addressCode = vm.location_code || "";
          vm.result.houseNo = deliveryAddress && deliveryAddress.house_no || "";
          vm.result.landmark = deliveryAddress && deliveryAddress.landmark || "";
          vm.result.unitNo = deliveryAddress && deliveryAddress.unit_no || "";
          vm.arrItems = vm.oldOrder ? vm.oldOrder.order_items : [];
          vm.subTotal = vm.oldOrder ? vm.oldOrder.sub_total : 0;
          vm.reOrderItems = vm.arrItems.slice(0, 3);
          if (vm.arrItems.length <= vm.limitShowMore) {
            vm.limitShowMore = vm.reOrderItems.length - 1;
            vm.showViewMore = false;
          } else {
            vm.limitShowMore = vm.$const.LIMIT_VIEW_MORE - 1;
            vm.showViewMore = true;
          }
          
          vm.setSelectedAddress(vm.oldOrder.address_code2)

        },
        function(err) {
          console.log("err_getLastOrder", err);
        }
      );
    },
    setSelectedAddress(location_code) {
      var vm = this

      this.axios.apiOutlet.getAddressByAddressCode({address_code: location_code}, (response) => {
        let data = response.data.data.items
        if (data.length > 0) {
          vm.result.prefectureName = data[0].level1 || ''
          vm.result.cityName = data[0].level2 || ''
          vm.result.villeageName = data[0].level3 || ''
          vm.result.st = data[0].level4 || ''
        } else {
          vm.$modal.show('dialog', {
            text: vm.$t('get_address_error'),
            buttons: [
              {
                title: vm.$t('button_yes')
              }
            ]
          })
        }
      })
    },
    showAll() {
      this.viewMore = !this.viewMore;
      if (!this.viewMore) {
        this.reOrderItems = this.arrItems;
        this.limitShowMore = this.arrItems.length - 1;
        return;
      }
      this.reOrderItems = this.arrItems.slice(0, 3);
      this.limitShowMore = this.$const.LIMIT_VIEW_MORE - 1;
    },
    reOrder() {
      let vm = this;
      vm.params.last_cart_uuid = vm.oldOrder.cart_uuid;
      vm.params.order_type = vm.oldOrder.order_type;
      vm.params.outlet_id = vm.oldOrder.outlet_id;
      vm.params.order_time = vm.convertDateTimeToUTC("");
      vm.params.advance_order = 0;
      vm.params.outlet_code = vm.oldOrder.outlet_code;
      if (vm.$session.get("disposition")) {
        vm.params.order_time = vm.convertDateTimeFromTimezoneToUTC(
          vm.$disposition.getByKey(vm, "timezone", ""),
          vm.$disposition.getByKey(vm, "collectionTimeValue", "")
        );
        vm.params.advance_order =
          vm.$disposition.getByKey(vm, "advanceOrder", 0) || 0;
      }
      vm.axios.apiCart.reOrderCart(
        vm.params,
        function(response) {
          if (!response.data.status) return;
          let cart = response.data.data.item
          vm.proceessDispostion()
          vm.$root.$emit('onReInitHeader')
          vm.$session.set('cart', cart)
          vm.$root.$emit('cartUpdate')
          // if (vm.isMobile()) {
          //   vm.$root.$emit('showHideCart', true)
          // }
          vm.$router.push({ 'name': 'category', 'params': { 'slug': vm.$const.MENU_DEFAULT, 'callFromROLO': true } })
        },
        function(error) {
          vm.sendEventGA(vm, 'CVR', `reOrder_Last_Order_error_${error.error.code}`, 'error', null, false)
          let message = vm.getMessageFromGms(error)
          vm.$modal.show('dialog', {
            text: message,
            buttons: [
              {
                title: vm.$t('button_close')
              }
            ]
          })
        }
      );
    },
    /**
     * Checking outlet is available
     * */
    checkValidOutlet() {
      var vm = this
      vm.sendEventGA(vm, 'CVR', 'click_button_ReOrder_LastOrder', 'clicked', null, true)
      if(vm.result.orderType === vm.$const.DELIVERY.charAt(0) && (!vm.result.prefectureName || !vm.result.cityName || !vm.result.villeageName)) {
        vm.$modal.show('dialog', {
          text: vm.$t('get_address_error'),
          buttons: [
            {
              title: vm.$t('button_yes')
            }
          ]
        })
        return
      }
      let data = {
        order_type: vm.oldOrder.order_type,
        order_time: !this.$session.get("disposition")
          ? this.convertDateTimeToUTC("")
          : this.convertDateTimeFromTimezoneToUTC(
            this.$disposition.getByKey(this, "timezone", ""),
            this.$disposition.getByKey(this, "collectionTimeValue", "")
          ),
        advance_order: !this.$session.get("disposition") ? 0 : this.$disposition.getByKey(this, 'advanceOrder', 0) || 0,
        outlet_id: vm.oldOrder.outlet_id
      }
      this.axios.apiOutlet.checkOutletAvailable(data,
        function (response) {
          response = response.data
          if (response.status) {
            let data = vm.$disposition.get(vm)
            response = response.data.item
            // set data
            data.prefectureName = vm.result.prefectureName || ''
            data.cityName = vm.result.cityName || ''
            data.villeageName = vm.result.villeageName || ''
            data.st = vm.result.st || ''
            data.lat = response.lat
            data.long = response.long
            data.postalCode = response.zip
            data.locationName = vm.result.locationName
            data.outletAddress = response.address
            data.orderType = vm.result.orderType == vm.$const.DELIVERY.charAt(0) ? vm.$const.DELIVERY : vm.$const.CARRYOUT
            data.outletId = response.id
            data.outletName = response.name
            data.outletCode = response.code
            data.outletPhone = response.phone
            data.addressCode = vm.result.orderType == vm.$const.DELIVERY.charAt(0) ? vm.result.addressCode : ''
            data.advanceOrder = vm.$disposition.getByKey(vm, 'advanceOrder', 0) || 0
            data.tier = response.tier
            data.minCart = response.min_cart
            data.houseNo = vm.result.houseNo || ''
            data.landmark = vm.result.landmark || ''
            data.unitNo = vm.result.unitNo || ''
            data.quoteTime = response.quote_time
            data.timezone = response.timezone
            data.customize = response.customize || {}
            data.takeaWayLess = vm.result.orderType == vm.$const.CARRYOUT.charAt(0) ? (vm.result.takeaWayLess || 0) : 0
            data.reOrder = 1
            vm.disposition = data
            let cart = vm.$cart.get(vm)
            if (data.takeaWayLess) {
              vm.setShowModalTakeAwayLess(true)
            }
            if (cart.uuid && cart.data.length > 0) {
              vm.$modal.show('dialog', {
                text: vm.$t('confirm.remove_cart'),
                buttons: [
                  {
                    title: vm.$t('button_yes'),
                    handler: () => {
                      vm.$modal.hide('dialog')
                      
                      vm.reOrder()
                    }
                  },
                  {
                    title: vm.$t('button_close')
                  }
                ]
              })
            } else {
              vm.reOrder()
            }
          } else if (response.message && response.message != '') {
            vm.$notify({
              type: 'warn',
              title: response.message
            })
          }
        },
        function (error) {
          error = error.error
          let message = false
          if (error.message) {
            message = error.message
          }
          console.log("error.code ", error.code )
          vm.eventTrackingLocalisationError({id: 'error-localization', error: 'invalid-localisation'})
          /*DEAD TRACKING*/
          if (vm.$const.LOCALIZATION_CODE.DELIVERY_DEADZONE.indexOf(error.code) > -1) {
            if(error.data && error.data.division && error.data.division.C && error.data.division.D)
            {
              if(error.data.division.C === 2 && error.data.division.D ===2){
                vm.eventTrackingHutClosed(data.outlet_id)
              }else{
                vm.eventTrackingDeliveryDeadZone('UnAvailable')
              }
            }
          } else if (vm.$const.LOCALIZATION_CODE.HUT_CLOSED.indexOf(error.code) > -1) {
            vm.eventTrackingHutClosed(data.outlet_id)
          } else if (vm.$const.LOCALIZATION_CODE.HUT_BOUNCING.indexOf(error.code) > -1){
            vm.evenTrackingHutIsBouncing(data.outlet_id)
          }
          /*END*/
          if (error.code == vm.$const.LOCALIZATION_CODE.UNAVALIABLE) {
            message = vm.$t('message_find_outlet_unavailable')
            vm.$modal.show('dialog', {
              text: message,
              buttons: [
                {
                  title: vm.$t('button_close')
                }
              ]
            })
          } else if (error.code == vm.$const.LOCALIZATION_CODE.NOTRECEIPT) {
            message = vm.$t('localization.notopen')
            vm.$modal.show('dialog', {
              text: message,
              buttons: [
                {
                  title: vm.$t('button_close'),
                  handler: () => {
                    vm.$modal.hide('dialog')
                    vm.$session.remove('cart')
                    vm.$session.remove('disposition')
                    vm.$root.$emit('cartUpdate')
                    vm.$root.$emit('onReInitHeader')
                  }
                }
              ]
            })
          } else if (error.code == vm.$const.CHECKOUT_SHOW_ASAP.HUTFE_14) {
            message = vm.$t('order.error_code.code14',{'store_name':error.data.name, 'store_phone': error.data.phone})
            vm.$modal.show(ASAPPopup, {
              outletId: vm.result.outletId,
              orderType: vm.result.orderType == vm.$const.CARRYOUT.charAt(0) ? vm.$const.CARRYOUT : vm.$const.DELIVERY,
              outletDataLocalization: vm.result,
              hideASAP: 'true',
              message: message,
              reOrder: 1
            })
          } else {
            message = vm.$t('modal.advance_order_message')
            //vm.$modal.show(ConfirmOrderAdvance, {message: message, outletId: vm.result.outletId, outletDataLocalization: vm.result, orderType: vm.orderType})
            vm.$modal.show(ASAPPopup, {
              outletId: vm.result.outletId,
              orderType: vm.result.orderType == vm.$const.CARRYOUT.charAt(0) ? vm.$const.CARRYOUT : vm.$const.DELIVERY,
              outletDataLocalization: vm.result,
              hideASAP: 'true',
              message: message,
              reOrder: 1
            })
          }
        }
      )
    },
    proceessDispostion() {
      this.$disposition.set(this, this.disposition)
      this.setDisposition(this.disposition)
      // this.showHideMap(true)
      this.$session.remove('cart')
      this.$root.$emit('cartUpdate')
      this.eventTrackingLocalisationSuccess(this)
      if (this.isReInitHeader) {
        this.$root.$emit('onReInitHeader')
      }
      if (this.$route.query.callback && this.$route.query.callback.length > 0) {
        this.$router.push(this.$route.query.callback)
      } else {
        //this.$root.$emit('onProcessChangeCategory')
        this.callEventBus(this.$const.EVENT_BUS.LOAD_CATEGORY, true)
        // this.redirectToPage(this.$const.SLUG_LIST.DEAL, this.$route.query)
        this.redirectToMenuPage()
      }
    },
  }
};
</script>
<style scoped>
.price {
  margin-left: auto;
}
#item-order>span {
  font-weight: bold;
}
.last-address {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3%;
  font-weight: 400;
  text-align: center;
  background-color: #F5F7F9;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 4px;
}
.item-re-order {
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 14px;
}
.sub-item {
  font-weight: 300;
  font-family: 'SharpSansSimiBold';
  width: 120%;
}
.mr-l-4 {
  margin-left: 4%;
}
.dpl-block {
  display: block;
}
.btn-re-order {
  border-radius: 3px;
  line-height: 1;
  width: 100%;
}
.fl-left {
  float: left;
}
.fl-right {
  float: right;
}
.aline-mid {
  font: normal normal normal 18px/1.2 "FontAwesome" !important;
  margin-left: 5px;
}
.color-view-more {
  color: #70a401;
}
</style>


// WEBPACK FOOTER //
// src/components/home/HomeReOrder.vue